import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import axiosApiInstance from "app/services/axios";
import cloneDeep from "lodash.clonedeep";

import {
  dataStoreRealTimeTable,
  eventHourlyReportingTable,
  getDataEndPoint,
  getReportingDataEndPoint,
} from "app/utils/constants/paths";
//import axiosApiInstance from "../../axios";
import { toast } from "react-toastify";
// import { stubFalse } from "lodash";
//import cloneDeep from "lodash/cloneDeep";
import { format } from "date-fns";
import { getDashboardFilter } from "app/utils/utils";

import moment from "moment";
import { REPORTING_INHOUSE_DSPS } from "app/utils/constants/configurations";
import { DATASOURCE_CONFIG } from "app/config";
const tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const convertStringToInt = (jsonArray) => {
  return jsonArray.map((obj) => {
    for (let prop in obj) {
      if (
        prop != "date" &&
        typeof obj[prop] === "string" &&
        Number.isInteger(parseInt(obj[prop]))
      ) {
        obj[prop] = parseInt(obj[prop]);
      }
    }
    return obj;
  });
};

const dayHours = [
  "00",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
];
const initialState = {
  reportingFilters: {
    start_date: moment(new Date()).format("YYYY-MM-DD 00:00:00"),
    end_date: moment(new Date()).format("YYYY-MM-DD 23:59:59"),
    accounts: [],
    advertisers: [],
    campaigns: [],
    banners: [],
  },
  loading: false,
  tileLoading: false,
  openRequestLoading: false,
  totalRequestLoading: false,
  dailyActiveUsersLoading: false,
  totalUsersLoading: false,
  chartLoading: false,
  userTilesList: [],
  globalAccountsList: [],
  publishersList: [],
  openRequests: {
    title: "Open Requests",
    tileValue: 0,
    color: "#1976d2",
    bgColor: "#ffffff",
    iconColor: "#3BD2A2",
    graphData: [],
  },
  totalRequests: {
    title: "Total Requests",
    tileValue: 0,
    color: "#1976d2",
    bgColor: "#ffffff",
    iconColor: "#3BD2A2",
    graphData: [],
  },
  dailyActiveUsers: {
    color: "#1976d2",
    bgColor: "#ffffff",
    iconColor: "#3BD2A2",
    title: "Daily Active Users",
    tileValue: 0,
    tardeValue: 0,
    tradeType: "up",
  },
  totalUsers: {
    color: "#1976d2",
    bgColor: "#ffffff",
    iconColor: "#3BD2A2",
    title: "Total Users",
    tileValue: 0,
    tardeValue: 0,
    tradeType: "up",
  },
  dashboardCardsList: [
    {
      title: "Open Requests",
      tileValue: 0,
      color: "#1976d2",
      bgColor: "#ffffff",
      iconColor: "#3BD2A2",
    },
    {
      title: "Total Requests",
      tileValue: 0,
      color: "#1976d2",
      bgColor: "#ffffff",
      iconColor: "#3BD2A2",
    },
    {
      color: "#1976d2",
      bgColor: "#ffffff",
      iconColor: "#3BD2A2",
      title: "Daily Active Users",
      tileValue: 0,
      tardeValue: 0,
      tradeType: "up",
    },
    {
      color: "#1976d2",
      bgColor: "#ffffff",
      iconColor: "#3BD2A2",
      title: "Total Users",
      tileValue: 0,
      tardeValue: 0,
      tradeType: "down",
    },
  ],
  //dashboardCrmUserData: [],
  //selGlobalAccount: { id: 1, label: "Account_1" },
  //globalStartDate: format(new Date("2022/12/14"), "yyyy-MM-dd 00:00:00"),
  //globalEndDate: format(new Date(), "yyyy-MM-dd 23:59:59"),
  reportingTiles: {},
  reportingOverviewGraphData: [],
  reportingTabsData: {},
  tabLoaders: [],
};
const getuiDateFormat = (type) => {
  let uiDateFormat = "HH24";
  if (type == "day") {
    uiDateFormat = "HH24";
  } else if (type == "week") {
    uiDateFormat = "MM/DD";
  } else if (type == "last_week") {
    uiDateFormat = "MM/DD";
  } else if (type == "last_month") {
    uiDateFormat = "MM/DD";
  }
  return uiDateFormat;
};
const getPreviousDates = (type, startDate) => {
  var prevType = "";
  if (type == "day") {
    prevType = "last_day";
  } else if (type == "week" || type == "last_week") {
    prevType = "last_week";
  } else if (type == "last_month") {
    prevType = "last_month";
  }
  var previousDates = getDashboardFilter(prevType, startDate);
  return previousDates;
};
const claculatePercentage = (previous, current) => {
  var percentage = 0;
  var def = parseFloat(parseFloat(current) - parseFloat(previous));
  if (parseFloat(previous) == 0 && parseFloat(current) == 0) {
    percentage = 0;
  } else if (parseFloat(previous) <= 0) {
    percentage = 100;
  } else {
    percentage = (def / parseFloat(previous)) * 100;
  }
  return percentage.toFixed(2);
};
export const GetOpenRequestsDataThunk = createAsyncThunk(
  "dashboard/GetOpenRequestsDataThunk",
  async (payload) => {
    let selCoulmns = "";
    let groupBy = "group by ui_date";
    let orderBy = "order by ui_date asc";
    let uiDateFormat = "";
    if (payload.type == "day") {
      uiDateFormat = "HH24";
    } else if (payload.type == "week") {
      uiDateFormat = "MM/DD";
    } else if (payload.type == "last_week") {
      uiDateFormat = "MM/DD";
    } else if (payload.type == "last_month") {
      uiDateFormat = "MM/DD";
    } else {
      uiDateFormat = "HH24";
    }
    selCoulmns =
      "count(id) as count,TO_CHAR(CONVERT_TIMEZONE('UTC', 'UTC', creation_date),'" +
      uiDateFormat +
      "') as ui_date";
    const queryBody = {
      queries: [
        {
          //Get Open Requests Query
          query:
            "select " +
            selCoulmns +
            " from " +
            tablePrefix +
            "requests_" +
            payload.account_id +
            " where account_id='" +
            payload.account_id +
            "' and status='-1' and creation_date >='" +
            payload.startDate +
            "' and creation_date <='" +
            payload.endDate +
            "' " +
            groupBy +
            " " +
            orderBy +
            " ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetTotalRequestsDataThunk = createAsyncThunk(
  "dashboard/GetTotalRequestsDataThunk",
  async (payload) => {
    console.log("Reuest:", payload);

    let selCoulmns = "";
    let groupBy = "group by ui_date";
    let orderBy = "order by ui_date asc";
    let uiDateFormat = getuiDateFormat(payload.type);

    selCoulmns =
      "count(id) as count,TO_CHAR(CONVERT_TIMEZONE('UTC', 'UTC', creation_date),'" +
      uiDateFormat +
      "') as ui_date";
    const queryBody = {
      queries: [
        {
          //Get Open Requests Query
          query:
            "select " +
            selCoulmns +
            " from " +
            tablePrefix +
            "requests_" +
            payload.account_id +
            " where account_id='" +
            payload.account_id +
            "' and creation_date >='" +
            payload.startDate +
            "' and creation_date <='" +
            payload.endDate +
            "' " +
            groupBy +
            " " +
            orderBy +
            " ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetDailyActiveUsersDataThunk = createAsyncThunk(
  "dashboard/GetDailyActiveUsersDataThunk",
  async (payload) => {
    var previousDates = getPreviousDates(payload.type, payload.startDate);
    let selCoulmns = "";
    let groupBy = "group by ui_date";
    let orderBy = "order by ui_date asc";
    let uiDateFormat = getuiDateFormat(payload.type);
    selCoulmns =
      "count(DISTINCT user_id) as count,TO_CHAR(CONVERT_TIMEZONE('UTC', 'UTC', creation_date),'" +
      uiDateFormat +
      "') as ui_date";
    const queryBody = {
      queries: [
        {
          //Get Open Requests Query
          query:
            "select " +
            selCoulmns +
            " from " +
            tablePrefix +
            "consent_" +
            payload.account_id +
            " where account_id='" +
            payload.account_id +
            "' and creation_date >='" +
            payload.startDate +
            "' and creation_date <='" +
            payload.endDate +
            "' " +
            groupBy +
            " " +
            orderBy +
            " ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          //Get Previous Active Users
          query:
            "select count(DISTINCT user_id) as count from " +
            tablePrefix +
            "consent_" +
            payload.account_id +
            " where account_id='" +
            payload.account_id +
            "' and creation_date >='" +
            previousDates.startDate +
            "' and creation_date <='" +
            previousDates.endDate +
            "' ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetTotalUsersDataThunk = createAsyncThunk(
  "dashboard/GetTotalUsersDataThunk",
  async (payload) => {
    var previousDates = getPreviousDates(payload.type, payload.startDate);
    let selCoulmns = "";
    let groupBy = "group by ui_date";
    let orderBy = "order by ui_date asc";
    let uiDateFormat = getuiDateFormat(payload.type);
    selCoulmns =
      "count(DISTINCT user_id) as count,TO_CHAR(CONVERT_TIMEZONE('UTC', 'UTC', creation_date),'" +
      uiDateFormat +
      "') as ui_date";
    const queryBody = {
      queries: [
        {
          //Get Total Users Query
          query:
            "select " +
            selCoulmns +
            " from " +
            tablePrefix +
            "consent_" +
            payload.account_id +
            " where account_id='" +
            payload.account_id +
            "' and creation_date >='" +
            payload.startDate +
            "' and creation_date <='" +
            payload.endDate +
            "' " +
            groupBy +
            " " +
            orderBy +
            " ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          //Get Previous Total Users
          query:
            "select count(DISTINCT user_id) as count from " +
            tablePrefix +
            "consent_" +
            payload.account_id +
            " where account_id='" +
            payload.account_id +
            "' and creation_date >='" +
            previousDates.startDate +
            "' and creation_date <='" +
            previousDates.endDate +
            "' ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          //Get Current Total Users
          query:
            "select count(DISTINCT user_id) as count from " +
            tablePrefix +
            "consent_" +
            payload.account_id +
            " where account_id='" +
            payload.account_id +
            "' ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetDashboardTilesDataThunk = createAsyncThunk(
  "dashboard/GetDashboardTilesDataThunk",
  async (payload) => {
    console.log(payload);
    var today = new Date();
    var yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();
    var todayDate = yyyy + "-" + mm + "-" + dd;
    const queryBody = {
      queries: [
        {
          //Get Open Requests Query
          query:
            "select count(id) as open_requests from " +
            tablePrefix +
            "requests_" +
            payload.account_id +
            " where account_id='" +
            payload.account_id +
            "' and status='-1' and creation_date >='" +
            payload.startDate +
            "' and creation_date <='" +
            payload.endDate +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          //Get Total Requests Query
          query:
            "select count(*) as total_requests from " +
            tablePrefix +
            "requests_" +
            payload.account_id +
            " where account_id='" +
            payload.account_id +
            "' and creation_date >='" +
            payload.startDate +
            "' and creation_date <='" +
            payload.endDate +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          //Get Total Daily Active Users Query
          query:
            "select count(DISTINCT user_id) as daily_users from " +
            tablePrefix +
            "consent_" +
            payload.account_id +
            " where account_id='" +
            payload.account_id +
            "' and creation_date >='" +
            payload.startDate +
            "' and creation_date <='" +
            payload.endDate +
            "' ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          //Get Total Users Query
          query:
            "select count(DISTINCT user_id) as total_users from " +
            tablePrefix +
            "consent_" +
            payload.account_id +
            " where account_id='" +
            payload.account_id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

//Reporting Changes - Need to move to Reporting Slice

export const GetReportingTilesDataThunk = createAsyncThunk(
  "dashboard/GetReportingTilesDataThunk",
  async (payload) => {
    console.log("dashboardDateFilter is updated now calling api");
    //console.log("Applied Filters:", state.reportingFilters);
    // var today = new Date();
    // var yyyy = today.getFullYear();
    // let mm = today.getMonth() + 1; // Months start at 0!
    // let dd = today.getDate();
    // var todayDate = yyyy + "-" + mm + "-" + dd;

    // let campaignIdFilter = "";
    // if (payload && payload.campaignId) {
    //   campaignIdFilter = "AND hourly.cid IN('" + payload.campaignId + "')";
    // }

    let start_date = payload.start_date;
    let end_date = payload.end_date;
    let accounts = payload.accounts;
    let advertisers = payload.advertisers;
    let campaigns = payload.campaigns;
    let banners = payload.banners;
    let inhouseDSPStr =
      REPORTING_INHOUSE_DSPS.length > 0
        ? "'" + REPORTING_INHOUSE_DSPS.join("','") + "'"
        : "";

    let WC = [];

    WC.push(
      `date_time >= CONVERT_TIMEZONE('America/New_York','UTC','${start_date}') and date_time < CONVERT_TIMEZONE('America/New_York','UTC','${end_date}') `
    );

    if (inhouseDSPStr != "") {
      WC.push(`hourly.dspid IN(${inhouseDSPStr})`);
    }
    if (accounts.length > 0) {
      let accountsStr = "'" + accounts.join("','") + "'";
      WC.push(`hourly.dsp_account_id IN(${accountsStr})`);
    }
    if (advertisers.length > 0) {
      let advsStr = "'" + advertisers.join("','") + "'";
      WC.push(`hourly.advertiser_id IN(${advsStr})`);
    }
    if (campaigns.length > 0) {
      let campaignsStr = "'" + campaigns.join("','") + "'";
      WC.push(`hourly.cid IN(${campaignsStr})`);
    }
    if (banners.length > 0) {
      let bannersStr = "'" + campaigns.join("','") + "'";
      WC.push(`hourly.crid IN(${bannersStr})`);
    }

    let whrCondition = "";
    if (WC.length > 0) {
      whrCondition = " where " + WC.join(" and ");
    }

    var q =
      "select SUM(A.requests) as requests,SUM(A.impressions) as impressions,SUM(A.viewables) as viewables,SUM(A.uniques) as uniques,SUM(A.clicks) as clicks, SUM(A.datacost) as datacost,SUM(A.attribution_cost) as attribution_cost, SUM(A.margin) as margin, SUM(A.spend) as spend, SUM(A.net) as net,SUM(A.load) as load, SUM(A.start) as start, SUM(A.first_quartile) as first_quartile, SUM(A.mid_point) as mid_point, SUM(A.third_quartile) as third_quartile, SUM(A.complete) as complete,SUM(A.close) as close, SUM(A.conversions) as conversions, SUM(A.roi) as roi from ((select SUM(CASE when EVENT_ID = 0 then total_count ELSE 0 END) as requests,SUM(CASE when EVENT_ID = 1 then total_count ELSE 0 END) as impressions, SUM(CASE when EVENT_ID = 3 then total_count ELSE 0 END) as clicks, SUM(CASE when EVENT_ID = 4 then total_count ELSE 0 END) as conversions, SUM(CASE when EVENT_ID = 5 then total_count ELSE 0 END) as load, SUM(CASE when EVENT_ID = 6 then total_count ELSE 0 END) as start, SUM(CASE when EVENT_ID = 7 then total_count ELSE 0 END) as first_quartile, SUM(CASE when EVENT_ID = 8 then total_count ELSE 0 END) as mid_point, SUM(CASE when EVENT_ID = 9 then total_count ELSE 0 END) as third_quartile, SUM(CASE when EVENT_ID = 10 then total_count ELSE 0 END) as complete, SUM(CASE when EVENT_ID = 11 then total_count ELSE 0 END) as close, SUM(CASE when EVENT_ID = 13 then total_count ELSE 0 END) as viewables,   0 as uniques,SUM(hourly.total_get_from_direct+hourly.attribution_cost_gross) as spend, SUM(hourly.datacost) as datacost, SUM(hourly.attribution_cost_gross) as attribution_cost, SUM(hourly.margin) as margin, SUM(hourly.total_pay_to_pub) as net, SUM(hourly.roi_gross) as roi  from " + eventHourlyReportingTable + "  as hourly  " +
      whrCondition +
      ") union (select SUM(CASE when EVENT_ID = 0 then total_count ELSE 0 END) as requests,SUM(CASE when EVENT_ID = 1 then total_count ELSE 0 END) as impressions, SUM(CASE when EVENT_ID = 3 then total_count ELSE 0 END) as clicks, SUM(CASE when EVENT_ID = 4 then total_count ELSE 0 END) as conversions, SUM(CASE when EVENT_ID = 5 then total_count ELSE 0 END) as load, SUM(CASE when EVENT_ID = 6 then total_count ELSE 0 END) as start, SUM(CASE when EVENT_ID = 7 then total_count ELSE 0 END) as first_quartile, SUM(CASE when EVENT_ID = 8 then total_count ELSE 0 END) as mid_point, SUM(CASE when EVENT_ID = 9 then total_count ELSE 0 END) as third_quartile, SUM(CASE when EVENT_ID = 10 then total_count ELSE 0 END) as complete, SUM(CASE when EVENT_ID = 11 then total_count ELSE 0 END) as close, SUM(CASE when EVENT_ID = 13 then total_count ELSE 0 END) as viewables,  0 as uniques, SUM(hourly.total_get_from_direct+hourly.attribution_cost_gross) as spend, SUM(hourly.datacost) as datacost, SUM(hourly.attribution_cost_gross) as attribution_cost, SUM(hourly.margin) as margin, SUM(hourly.total_pay_to_pub) as net, SUM(hourly.roi_gross) as roi  from " + dataStoreRealTimeTable + " as hourly " +
      whrCondition +
      ")) A";
    // if (payload && payload.campaignId) {
    //   q =
    //     "select SUM(A.requests) as requests,SUM(A.impressions) as impressions,SUM(A.viewables) as viewables,SUM(A.uniques) as uniques,SUM(A.clicks) as clicks, SUM(A.datacost) as datacost,SUM(A.attribution_cost) as attribution_cost, SUM(A.margin) as margin, SUM(A.spend) as spend, SUM(A.net) as net,SUM(A.load) as load, SUM(A.start) as start, SUM(A.first_quartile) as first_quartile, SUM(A.mid_point) as mid_point, SUM(A.third_quartile) as third_quartile, SUM(A.complete) as complete,SUM(A.close) as close, SUM(A.conversions) as conversions, SUM(A.roi) as roi, account_id from ((select SUM(CASE when EVENT_ID = 0 then total_count ELSE 0 END) as requests,SUM(CASE when EVENT_ID = 1 then total_count ELSE 0 END) as impressions, SUM(CASE when EVENT_ID = 3 then total_count ELSE 0 END) as clicks, SUM(CASE when EVENT_ID = 4 then total_count ELSE 0 END) as conversions, SUM(CASE when EVENT_ID = 5 then total_count ELSE 0 END) as load, SUM(CASE when EVENT_ID = 6 then total_count ELSE 0 END) as start, SUM(CASE when EVENT_ID = 7 then total_count ELSE 0 END) as first_quartile, SUM(CASE when EVENT_ID = 8 then total_count ELSE 0 END) as mid_point, SUM(CASE when EVENT_ID = 9 then total_count ELSE 0 END) as third_quartile, SUM(CASE when EVENT_ID = 10 then total_count ELSE 0 END) as complete, SUM(CASE when EVENT_ID = 11 then total_count ELSE 0 END) as close, SUM(CASE when EVENT_ID = 13 then total_count ELSE 0 END) as viewables,   0 as uniques,SUM(hourly.total_get_from_direct+hourly.attribution_cost_gross) as spend, SUM(hourly.datacost) as datacost, SUM(hourly.attribution_cost_gross) as attribution_cost, SUM(hourly.margin) as margin, SUM(hourly.total_pay_to_pub) as net, SUM(hourly.roi_gross) as roi  ,hourly.dsp_account_id as account_id  from neptune.neptune.events_hourly_reporting_test  as hourly  where date_time >= CONVERT_TIMEZONE('America/New_York','UTC','" +
    //     payload.sdate +
    //     "') AND date_time < CONVERT_TIMEZONE('America/New_York','UTC','" +
    //     payload.edate +
    //     "')  AND hourly.cid IN(" +
    //     payload.campaignId +
    //     ") Group by account_id) union (select SUM(CASE when EVENT_ID = 0 then total_count ELSE 0 END) as requests,SUM(CASE when EVENT_ID = 1 then total_count ELSE 0 END) as impressions, SUM(CASE when EVENT_ID = 3 then total_count ELSE 0 END) as clicks, SUM(CASE when EVENT_ID = 4 then total_count ELSE 0 END) as conversions, SUM(CASE when EVENT_ID = 5 then total_count ELSE 0 END) as load, SUM(CASE when EVENT_ID = 6 then total_count ELSE 0 END) as start, SUM(CASE when EVENT_ID = 7 then total_count ELSE 0 END) as first_quartile, SUM(CASE when EVENT_ID = 8 then total_count ELSE 0 END) as mid_point, SUM(CASE when EVENT_ID = 9 then total_count ELSE 0 END) as third_quartile, SUM(CASE when EVENT_ID = 10 then total_count ELSE 0 END) as complete, SUM(CASE when EVENT_ID = 11 then total_count ELSE 0 END) as close, SUM(CASE when EVENT_ID = 13 then total_count ELSE 0 END) as viewables,  0 as uniques, SUM(hourly.total_get_from_direct+hourly.attribution_cost_gross) as spend, SUM(hourly.datacost) as datacost, SUM(hourly.attribution_cost_gross) as attribution_cost, SUM(hourly.margin) as margin, SUM(hourly.total_pay_to_pub) as net, SUM(hourly.roi_gross) as roi  ,hourly.dsp_account_id as account_id  from neptune.neptune.data_store_real_time_test as hourly  where  date_time >= CONVERT_TIMEZONE('America/New_York','UTC','" +
    //     payload.sdate +
    //     "')  AND date_time < CONVERT_TIMEZONE('America/New_York','UTC','" +
    //     payload.edate +
    //     "')  AND hourly.cid IN(" +
    //     payload.campaignId +
    //     ") Group by account_id)) A  Group by account_id";
    // }

    console.log("Query:", q);
    const queryBody = {
      queries: [
        {
          query: q,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        getReportingDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetAccountPublishersListThunk = createAsyncThunk(
  "dashboard/GetAccountPublishersListThunk",
  async (payload) => {
    let selQuery = "";

    // selQuery =
    //   "select pub.id,pub.id as pub_id,pub.pub_code,pub.name,pub.accountid,pub.daily_active_users as dau,pub.monthly_active_users as mau,pub.total_users,(select count(*) from "+tablePrefix+"consent_" +
    //   payload.account_id +
    //   " where pub_id=pub.id and account_id='" +
    //   payload.account_id +
    //   "') as users from "+tablePrefix+"publishers as pub where pub.accountid='" +
    //   payload.account_id +
    //   "' order by pub.id asc";

    selQuery =
      "select pub.id,pub.id as pub_id,pub.pub_code,pub.name,pub.accountid,pub.daily_active_users as dau,pub.monthly_active_users as mau,pub.total_users,'Mobile Web' as type,(select LISTAGG(cspa.url,',') WITHIN GROUP (ORDER BY cspa.pub_id)  from " +
      tablePrefix +
      "crm_sources_pub_assoc_" +
      payload.account_id +
      " cspa where cspa.pub_id =pub.id limit 3) as url from " +
      tablePrefix +
      "publishers as pub where pub.accountid='" +
      payload.account_id +
      "' and pub.active='1' order by pub.id asc";
    const queryBody = {
      queries: [
        {
          query: selQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetCRMWiseUserDataThunk = createAsyncThunk(
  "dashboard/GetCRMWiseUserDataThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select count(user_id) as records,crm_source_id,(select name from " +
            tablePrefix +
            "crm_sources cs where cs.id=c.crm_source_id) as crm_name from " +
            tablePrefix +
            "consent_" +
            payload.account_id +
            " c where account_id ='" +
            payload.account_id +
            "' and creation_date >='" +
            payload.startDate +
            "' and creation_date <='" +
            payload.endDate +
            "' group by crm_source_id",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "select count(ou.user_id) as records,(select listagg(cs.name ,',') within group (order by cs.name) as val from " +
            tablePrefix +
            "consent_" +
            payload.account_id +
            " as crm_group," +
            tablePrefix +
            "crm_sources cs where cs.id=crm_group.crm_source_id and crm_group.user_id=ou.user_id) as crm_name from " +
            tablePrefix +
            "consent_" +
            payload.account_id +
            " ou where account_id='" +
            payload.account_id +
            "' and (select count(*) from " +
            tablePrefix +
            "consent_" +
            payload.account_id +
            " inr where inr.user_id = ou.user_id) > 1 and ou.creation_date >='" +
            payload.startDate +
            "' and ou.creation_date <='" +
            payload.endDate +
            "' group by ou.user_id",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetCRMDataByPubIdThunk = createAsyncThunk(
  "dashboard/GetCRMDataByPubIdThunk",
  async (payload) => {
    let QueryStr = "";
    if (DATASOURCE_CONFIG.DATASOURCE == "mysql") {
      QueryStr =
        "select concat(pub_assoc.pub_id,'_',pub_assoc.crm_source_id) as id,pub_assoc.daily_active_users as dau,pub_assoc.monthly_active_users as mau,pub_assoc.total_users,pub_assoc.url,(select name from " +
        tablePrefix +
        "crm_sources where id=pub_assoc.crm_source_id) as name,'Mobile Web' as type from " +
        tablePrefix +
        "crm_sources_pub_assoc_" +
        payload.account_id +
        " as pub_assoc where pub_assoc.account_id='" +
        payload.account_id +
        "' and pub_assoc.pub_id='" +
        payload.pub_id +
        "'";
    } else {
      // For Redshift database
      QueryStr =
        "select concat(concat(pub_assoc.pub_id,'_'),pub_assoc.crm_source_id) as id,pub_assoc.daily_active_users as dau,pub_assoc.monthly_active_users as mau,pub_assoc.total_users,pub_assoc.url,(select name from " +
        tablePrefix +
        "crm_sources where id=pub_assoc.crm_source_id) as name,'Mobile Web' as type from " +
        tablePrefix +
        "crm_sources_pub_assoc_" +
        payload.account_id +
        " as pub_assoc where pub_assoc.account_id='" +
        payload.account_id +
        "' and pub_assoc.pub_id='" +
        payload.pub_id +
        "'";
    }
    const queryBody = {
      queries: [
        {
          query: QueryStr,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
const Dashboard = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    logOut(state, action) {
      state.isLoggedIn = false;
      localStorage.clear();
      window.location.href = `/login`;
    },
    updateGlobalAccount(state, action) {
      state.selGlobalAccount = action.payload;
    },
    updateGlobalStartAndEndDate(state, action) {
      state.globalStartDate = action.payload.startDate + " 00:00:00";
      state.globalEndDate = action.payload.endDate + " 23:59:59";
    },
    updateTabLoaders(state, action) {
      state.tabLoaders = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      // .addCase(GetAllGlobalAccountsListThunk.pending, (state) => {
      //   state.loading = true;
      // })
      // .addCase(GetAllGlobalAccountsListThunk.fulfilled, (state, action) => {
      //   console.log("Account REs;", action.payload.data.results);
      //   state.globalAccountsList = action.payload.data.results[0];
      //   if (action.payload.data.status === 1) {
      //   } else if (action.payload.data.status == 0) {
      //     // toast.error(action.payload.data.message);
      //   }
      // })
      // .addCase(GetAllGlobalAccountsListThunk.rejected, (state, action) => {
      //   //toast.error('Something went Wrong!');
      // })
      .addCase(GetDashboardTilesDataThunk.pending, (state) => {
        state.tileLoading = true;
      })
      .addCase(GetDashboardTilesDataThunk.fulfilled, (state, action) => {
        const dbResponse = action.payload.data.results;
        state.dashboardCardsList = [
          {
            title: "Open Requests",
            tileValue: dbResponse[0][0].open_requests,
            color: "#1976d2",
            bgColor: "#ffffff",
            iconColor: "#3BD2A2",
          },
          {
            title: "Total Requests",
            tileValue: dbResponse[1][0].total_requests,
            color: "#1976d2",
            bgColor: "#ffffff",
            iconColor: "#3BD2A2",
          },
          {
            color: "#1976d2",
            bgColor: "#ffffff",
            iconColor: "#3BD2A2",
            title: "Daily Active Users",
            tileValue: dbResponse[2][0].daily_users,
            tardeValue: "0%",
            tradeType: "up",
            tooltip: "",
          },
          {
            color: "#1976d2",
            bgColor: "#ffffff",
            iconColor: "#3BD2A2",
            title: "Total Users",
            tileValue: dbResponse[3][0].total_users,
            tardeValue: "0%",
            tradeType: "down",
            tooltip: "",
          },
        ];
        state.tileLoading = false;
      })
      .addCase(GetDashboardTilesDataThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
      })
      .addCase(GetReportingTilesDataThunk.pending, (state) => {
        state.tileLoading = true;
      })
      .addCase(GetReportingTilesDataThunk.fulfilled, (state, action) => {
        const dbResponse = action.payload.data.results;
        if (dbResponse && dbResponse.length) {
          // console.log("dbResponse---", dbResponse[0][0]);
          state.reportingTiles = dbResponse[0][0];
        }
        state.tileLoading = false;
      })
      .addCase(GetReportingTilesDataThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
      })

      .addCase(GetAccountPublishersListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAccountPublishersListThunk.fulfilled, (state, action) => {
        var pubList = action.payload.data.results[0];
        var treePubList = [];

        for (var i = 0; i < pubList.length; i++) {
          var pbInfo = pubList[i];
          pbInfo.nodes = [];
          treePubList.push(pbInfo);
        }
        state.publishersList = treePubList;
        state.loading = false;
      })
      .addCase(GetAccountPublishersListThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
      })
      .addCase(GetCRMWiseUserDataThunk.pending, (state) => {
        state.chartLoading = true;
      })
      .addCase(GetCRMWiseUserDataThunk.fulfilled, (state, action) => {
        state.chartLoading = false;
      })
      .addCase(GetCRMWiseUserDataThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
      })
      .addCase(GetCRMDataByPubIdThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetCRMDataByPubIdThunk.fulfilled, (state, action) => {
        console.log(" Pub Res:", action.payload.data.results);
        //var currentPublishersState = cloneDeep(state.publishersList);
        var currentPublishersState = state.publishersList;
        console.log("currentPublishersState", currentPublishersState);
        for (var i = 0; i < currentPublishersState.length; i++) {
          if (currentPublishersState[i]["id"] == action.meta.arg.pub_id) {
            var childDataRes = action.payload.data.results[0];
            if (childDataRes.length > 0) {
              currentPublishersState[i]["nodes"] = childDataRes;
            } else {
              delete currentPublishersState[i]["nodes"]; // If childern data has empty , then removing nodes key
            }

            // for (var k = 0; k < childDataRes.length; k++) {
            //   currentPublishersState[i]["nodes"].push({
            //     data: childDataRes[k],
            //   });
            // }
          }
        }
        // currentPublishersState.find((element) => {
        //   if (element.data.id == action.meta.arg.pub_id) {
        //     return (element.data.children = [
        //       { data: action.payload.data.results },
        //     ]);
        //   }
        // });
        state.loading = false;
        console.log("currentPublishersState-Out", currentPublishersState);
        //state.publishersList = currentPublishersState;
      })
      .addCase(GetOpenRequestsDataThunk.pending, (state) => {
        state.openRequestLoading = true;
      })
      .addCase(GetOpenRequestsDataThunk.fulfilled, (state, action) => {
        const dbResponse = action.payload.data.results[0];
        const requestInfo = {};
        requestInfo.title = "Open Requests";
        requestInfo.tileValue = 0;
        requestInfo.color = "#1976d2";
        requestInfo.bgColor = "#ffffff";
        requestInfo.iconColor = "#3BD2A2";
        requestInfo.graphData = [];
        //{ ui_date: "Jan", count: 800 },
        var totalOpenRequests = 0;
        if (action.meta.arg.type == "day") {
          for (var i = 0; i < dayHours.length; i++) {
            var hour = dayHours[i];
            let obj = dbResponse.find((o) => o.ui_date == hour);
            if (obj) {
              requestInfo.graphData.push(obj);
            } else {
              requestInfo.graphData.push({
                count: 0,
                ui_date: hour,
              });
            }
          }
        } else {
          if (dbResponse.length > 0) {
            requestInfo.graphData = dbResponse;
          }
        }
        for (var k = 0; k < requestInfo.graphData.length; k++) {
          var uiInfo = requestInfo.graphData[k];
          totalOpenRequests += parseFloat(uiInfo["count"]);
        }
        requestInfo.tileValue = totalOpenRequests;
        state.openRequests = requestInfo;
        state.openRequestLoading = false;
      })
      .addCase(GetOpenRequestsDataThunk.rejected, (state, action) => {
        state.openRequestLoading = false;
      })
      .addCase(GetTotalRequestsDataThunk.pending, (state) => {
        state.totalRequestLoading = true;
      })
      .addCase(GetTotalRequestsDataThunk.fulfilled, (state, action) => {
        const dbResponse = action.payload.data.results[0];
        const requestInfo = {};

        requestInfo.title = "Total Requests";
        requestInfo.tileValue = 0;
        requestInfo.color = "#1976d2";
        requestInfo.bgColor = "#ffffff";
        requestInfo.iconColor = "#3BD2A2";
        requestInfo.graphData = [];
        //{ ui_date: "Jan", count: 800 },
        var totalRequests = 0;
        if (action.meta.arg.type == "day") {
          for (var i = 0; i < dayHours.length; i++) {
            var hour = dayHours[i];
            let obj = dbResponse.find((o) => o.ui_date == hour);
            if (obj) {
              requestInfo.graphData.push(obj);
            } else {
              requestInfo.graphData.push({
                count: 0,
                ui_date: hour,
              });
            }
          }
        } else {
          if (dbResponse.length > 0) {
            requestInfo.graphData = dbResponse;
          }
        }
        for (var k = 0; k < requestInfo.graphData.length; k++) {
          var uiInfo = requestInfo.graphData[k];
          totalRequests += parseFloat(uiInfo["count"]);
        }
        requestInfo.tileValue = totalRequests;
        state.totalRequests = requestInfo;
        state.totalRequestLoading = false;
      })
      .addCase(GetTotalRequestsDataThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.totalRequestLoading = false;
      })
      .addCase(GetDailyActiveUsersDataThunk.pending, (state) => {
        state.dailyActiveUsersLoading = true;
      })
      .addCase(GetDailyActiveUsersDataThunk.fulfilled, (state, action) => {
        const dbResponse = action.payload.data.results[0];
        const previousOpenReq = action.payload.data.results[1][0].count;
        console.log("previousOpenReq", previousOpenReq);
        const requestInfo = {};

        requestInfo.title = "Daily Active Users";
        requestInfo.tileValue = 0;
        requestInfo.color = "#1976d2";
        requestInfo.bgColor = "#ffffff";
        requestInfo.iconColor = "#3BD2A2";
        requestInfo.tardeValue = 0;
        requestInfo.tradeType = "down";
        requestInfo.graphData = [];

        //{ ui_date: "Jan", count: 800 },
        var users = 0;
        if (action.meta.arg.type == "day") {
          for (var i = 0; i < dayHours.length; i++) {
            var hour = dayHours[i];
            let obj = dbResponse.find((o) => o.ui_date == hour);
            if (obj) {
              requestInfo.graphData.push(obj);
            } else {
              requestInfo.graphData.push({
                count: 0,
                ui_date: hour,
              });
            }
          }
        } else {
          if (dbResponse.length > 0) {
            requestInfo.graphData = dbResponse;
          }
        }
        for (var k = 0; k < requestInfo.graphData.length; k++) {
          var uiInfo = requestInfo.graphData[k];
          users += parseFloat(uiInfo["count"]);
        }
        requestInfo.tileValue = users;
        var percentage = claculatePercentage(previousOpenReq, users);
        //requestInfo.tardeValue = 0;

        requestInfo.tardeValue = Math.abs(percentage);
        if (percentage < 0) {
          requestInfo.tradeType = "down";
          requestInfo.iconColor = "#e73145";
        } else {
          requestInfo.tradeType = "up";
        }
        state.dailyActiveUsers = requestInfo;
        state.dailyActiveUsersLoading = false;
      })
      .addCase(GetDailyActiveUsersDataThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.dailyActiveUsersLoading = false;
      })
      .addCase(GetTotalUsersDataThunk.pending, (state) => {
        //state.loading = true;
        state.totalUsersLoading = true;
      })
      .addCase(GetTotalUsersDataThunk.fulfilled, (state, action) => {
        const dbResponse = action.payload.data.results[0];
        const previousUsers = action.payload.data.results[1][0].count;
        const currentTotalUsers = action.payload.data.results[2][0].count;
        const requestInfo = {};

        requestInfo.title = "Total Users";
        requestInfo.tileValue = currentTotalUsers;
        requestInfo.color = "#1976d2";
        requestInfo.bgColor = "#ffffff";
        requestInfo.iconColor = "#3BD2A2";
        requestInfo.tardeValue = 0;
        requestInfo.tradeType = "down";
        requestInfo.graphData = [];

        //{ ui_date: "Jan", count: 800 },
        var users = 0;
        if (action.meta.arg.type == "day") {
          for (var i = 0; i < dayHours.length; i++) {
            var hour = dayHours[i];
            let obj = dbResponse.find((o) => o.ui_date == hour);
            if (obj) {
              requestInfo.graphData.push(obj);
            } else {
              requestInfo.graphData.push({
                count: 0,
                ui_date: hour,
              });
            }
          }
        } else {
          if (dbResponse.length > 0) {
            requestInfo.graphData = dbResponse;
          }
        }
        for (var k = 0; k < requestInfo.graphData.length; k++) {
          var uiInfo = requestInfo.graphData[k];
          users += parseFloat(uiInfo["count"]);
        }
        //requestInfo.tileValue = users;
        var percentage = claculatePercentage(previousUsers, users);
        //requestInfo.tardeValue = 0;

        requestInfo.tardeValue = Math.abs(percentage);
        if (percentage < 0) {
          requestInfo.tradeType = "down";
          requestInfo.iconColor = "#e73145";
        } else {
          requestInfo.tradeType = "up";
        }
        state.totalUsers = requestInfo;
        state.totalUsersLoading = false;
      })
      .addCase(GetTotalUsersDataThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.totalUsersLoading = false;
      });
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = Dashboard;
// Extract and export each action creator by name
export const {
  updateTabLoaders,
  updateReportingFilters,
  updateReportingFiltersDate,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
